export default "__VITE_ASSET__BX_AQYz4__"